<template>

  <span >
    <el-cascader
            clearable
            :size="size"
            :placeholder="placeholder"
            @change="handleModuleCodeChange"
            :options="options"
            :value="defaultModuleCode"
            change-on-select
    ></el-cascader>
    <input  type="text" :value="value" style='display:none;'>
  </span>
</template>

<script>

  export default {
    name:"ModuleCascader",
    components: {},
    props:{
      size:{
        type:String,
        default:''
      },
      value: {
        type: String,
        default:''
      },
      placeholder: {
        type: String,
        default:"选择所属模块"
      },

    },
    watch:{
      value(val) {
        if(!val){
          this.defaultModuleCode = []
        }
      }
    },

    data () {
      return {
        options: [],
        defaultModuleCode:[],
      }
    },
    computed: {},
    methods: {
      handleModuleCodeChange:function (e) {
        if(e[e.length - 1]){
          this.$emit('input', e[e.length - 1]);
        }else{
          this.$emit('input', "");
        }

      },

      loadModuleTree:function () {
        let vm = this;
        vm.$http.get(vm.$api.module.tree).then(function (resp) {
          vm.options = vm.moduleTreeToModuleOption(resp.data.data.moduleTree).children ;

          let getDefaultModuleCodeValue = function (code, options, result) {


            for (let e in options) {

              if (options[e].value === code) {
                result.push(options[e].value);
               // vm.defaultModuleCode =  result;
                return true ;

              } else if (options[e].children && options[e].children.length > 0) {
                if(getDefaultModuleCodeValue(code, options[e].children, result)){
                  result.push(options[e].value);
                  //vm.defaultModuleCode =  result.reverse();
                  return true ;
                }
              }
            }


            return false ;

          };

          if(vm.value){
            let result = [];
            getDefaultModuleCodeValue(vm.value, vm.options,result);
            vm.defaultModuleCode = result.reverse();
          }

          console.log(vm.defaultModuleCode);



        });
      },
      moduleTreeToModuleOption:function (moduleTree) {
        let vm = this ;
        let moduleOption = {};


        if(moduleTree.code){
          moduleOption.moduleOption = moduleTree.name;
          moduleOption.value = moduleTree.code;
          moduleOption.flag = moduleTree.flag;
          moduleOption.label = moduleTree.name;
        }

        if(moduleTree.children !== null && moduleTree.children.length > 0){
          moduleOption.children = [] ;
          moduleTree.children.forEach(function (e) {
            moduleOption.children.push(vm.moduleTreeToModuleOption(e));
          });
        }
        return moduleOption ;
      }
    },
    created: function () {
      this.loadModuleTree();

    }
  }
</script>

<style ref="stylesheet/scss" lang="scss">




</style>